<ng-template #childMenu>
    <div contextMenu cdkMenu>
        <span *ngFor="let child of items">
            <span *ngIf="child.children && child.children.length > 0">
                <button
                    cdkMenuItem
                    class="btn-mat-menu children {{ align }}"
                    [ngClass]="{ 'arrow-left': !isMobile }"
                    [cdkMenuTriggerFor]="menu.childMenu"
                    (click)="executeCommand(child)"
                >
                    <mat-icon>arrow_left</mat-icon>
                    <span>{{ child.displayName }}</span>
                </button>
                <app-header-menu #menu [items]="child.children" [align]="'left'"></app-header-menu>
            </span>
            <span *ngIf="!child.children || child.children.length === 0">
                <button
                    cdkMenuItem
                    class="btn-mat-menu {{ align }}"
                    (click)="executeCommand(child)"
                >
                    <mat-icon *ngIf="child.active" class="active-icon">check</mat-icon>
                    <span>{{ child.displayName }}</span>
                </button>
            </span>
        </span>
    </div>
</ng-template>
